import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authService } from '../services/authService';
import { useAuthStore } from '../store/authStore';
import { useToastStore } from '../store/toastStore';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { FormField } from '../components/ui/FormField';

export function LoginPage() {
  const navigate = useNavigate();
  const login = useAuthStore((s) => s.login);
  const showToast = useToastStore((s) => s.show);

  const [credential, setCredential] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.SubmitEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await authService.login({ credential, password });
      login(data.accessToken, data.customerId, data.name, data.isAdmin);
      navigate('/');
    } catch (err: any) {
      showToast(err?.response?.data?.errors?.[0] ?? 'Credenciais inválidas.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-sm p-8 w-full max-w-sm">
        <h1 className="text-2xl font-bold text-text-dark mb-1">Entrar</h1>
        <p className="text-text-light text-sm mb-6">Use seu e-mail ou telefone</p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <FormField label="E-mail ou telefone" required>
            <Input
              type="text"
              value={credential}
              onChange={(e) => setCredential(e.target.value)}
              placeholder="exemplo@email.com ou 85994322348"
              required
            />
          </FormField>

          <FormField label="Senha" required>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </FormField>

          <div className="text-right">
            <Link to="/esqueci-senha" className="text-chocolate hover:underline text-sm">
              Esqueci minha senha
            </Link>
          </div>

          <Button type="submit" fullWidth loading={loading}>
            Entrar
          </Button>
        </form>

        <p className="text-center text-sm text-text-light mt-4">
          Primeira vez?{' '}
          <Link to="/cadastro" className="text-chocolate hover:underline">
            Criar acesso
          </Link>
        </p>
      </div>
    </div>
  );
}
